import React, { Component, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const MasterEntry = () => {
  const { t } = useTranslation();
  const { name } = useParams();
  const [data, setData] = useState([]);
  const [templist, setTempList] = useState([]);
  const [searchTextVal, setSearchTextVal] = useState([]);
  const [mastervalue, setMastervalue] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_masterentry")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    fetchData();
  }, [name]);

  const categoryLabel =
  name === "productgroup"
    ? t("product_group_txt")
    : name === "suitablefor"
      ? t("suitable_for_txt")
      : name === "taxcode"
        ? t("tax_code_txt")
        : t("sector_txt");

  const editMaster = (value) => {
    window.location.href = `/master-entry/edit/${name}/${value._id}`;
  };

  const deleteMaster = (value) => {
    setVisibleAlert(true);
    setMastervalue(value);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + `admin/product/masterentries/${name}`;
      const response = await http.get(URL);
      let responseData = response.data.data;
      const sortedData = responseData.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );
      if (response.data.success === true) {
        setData(sortedData);
        setTempList(responseData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const addMaster = () => {
    window.location.href = `/master-entry/add/${name}`;
  };

  const deleteMastervalue = () => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + `admin/product/deletemaster/${mastervalue._id}`;
    http
      .delete(URL)
      .then(async (response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setMastervalue("");
  };

  const columns = [
    {
      name: t("category_value_txt", {
        category: categoryLabel,
      }),
      selector: (row) => row.MasterValue,
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => {
        const canEdit = canAction("manage_masterentry", "edit");
        return (
          <div style={{ display: "flex" }}>
            <a
              className="button title-tooltip title-up"
              data-title={canEdit ? t("edit_txt") : t("view_txt")}
              style={{ color: "white" }}
              onClick={() => editMaster(row)}
            >
              <i
                className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                aria-hidden="true"
              ></i>
            </a>
            {canAction("manage_masterentry", "delete") && (
              <a
                className="button title-tooltip title-up"
                data-title={t("delete_txt")}
                style={{ color: "white" }}
                onClick={() => deleteMaster(row)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
            )}
          </div>
        );
      },
      sortable: false,
    },
  ];

  const handleReset = () => {
    setSearchTextVal("");
    setData(templist);
  };

  const handleChange = async (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = async (value) => {
    let accoun = templist;
    const lowercasedValue = value.toLowerCase().trim();
    let result = [];
    if (lowercasedValue.length > 0) {
      accoun.map((item) => {
        if (
          item.MasterValue.toString().toLowerCase().includes(lowercasedValue)
        ) {
          result.push(item);
        }
      });
      setData(result);
    } else {
      setData(accoun);
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">
                {t("master_title_txt", {
                    category: categoryLabel,
                })}
            </h1>
            <div className="right-table-outer-wrap">
              <div className="table-filter search-orders">
                <div className="table-search-reset">
                  <div className="table-search">
                    <input
                      type="text"
                      value={searchTextVal}
                      onChange={(e) => handleChange(e.target.value)}
                      className="form-control"
                      placeholder={t("search_by_category_txt", {
                        category: categoryLabel,
                      })}
                    />
                  </div>
                  <button
                    className="submitbtn button search-ord-btn"
                    onClick={(e) => filterData(searchTextVal)}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                  <button
                    className="resetbtn"
                    type="reset"
                    onClick={() => handleReset()}
                  >
                    {t("reset_txt")}
                  </button>
                </div>
                {canAction("manage_masterentry", "add") && (
                  <div className="add-masterbtn">
                    <button className="addbtn" onClick={() => addMaster()}>
                      {t("add_txt")}
                    </button>
                  </div>
                )}
              </div>
              <div className="table_overflow">
                <DataTable
                  columns={columns}
                  noDataComponent={
                    <div className="no-records-found">
                      {t("no_matching_records_txt")}
                    </div>
                  }
                  data={data}
                  customStyles={customStyles}
                  pagination
                  paginationPerPage={25}
                  progressPending={isLoading}
                  paginationRowsPerPageOptions={[25, 50, 75, 100]}
                  paginationComponentOptions={paginationComponentOptions}
                />
              </div>
            </div>
            {visibleAlert && (
              <div className="custom-alert-pop paylater-popup">
                <div className="custom-alert-container">
                  <div className="custom-alert-wrap">
                    <div className="custom-alert-header">
                      <h4>{t("alert_txt")}</h4>
                    </div>
                    <div className="custom-alert-body">
                      <p>{t("confirm_delete_txt")}</p>
                      <div className="alert-buttons">
                        <a
                          onClick={() => deleteMastervalue()}
                          className="popup-alert-btn button"
                        >
                          {t("ok_txt")}
                        </a>
                        <a
                          onClick={() => alertPopupclose()}
                          className="popup-alert-btn button"
                        >
                          {t("cancel_txt")}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};
export default MasterEntry;
